export const COLORS = {
  primary_button: "#9cd6d1",
  onHold_button: "#009688",
  pulse_color: "#ff0404",
  signIn: "#000",
  grey: "#707070",
  white: "#fff",
  Button_OnHold: "#E1E1E1",
  bgColor: "#f4f2ee",
  primary_color: "#F4F5F7",
  title_color: '#004F98',
  button_color: '#0085FF',
  fieldTitle_color: '#0000004D',
};

const colors = {
  primary: '#0017E7', // done
  secondary: '#D9D9D9',// done
  primary_admin : '#E700C8',
  accent: '#e74c3c',
  background: '#ffffff',
  surface: '#f5f5f5',
  textPrimary: '#333333',
  textSecondary: '#666666',
  success: '#27ae60',
  error: '#e74c3c',
  border: '#e0e0e0',
  hover: '#2980b9',
  white: '#ffffff',
  black: '#000000',
};

export default colors;
